/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Checkbox } from '@carbon/react';

import { useRememberCredentials } from './use-remember-credentials';

export function RememberCredentials({ selectedCluster, clientId, setClientId, clientSecret, setClientSecret }) {
  const [rememberCredentials, setRememberCredentials] = useRememberCredentials({
    selectedClusterLSKey: selectedCluster?.urls?.zeebeGrpc,
    clientId,
    setClientId,
    clientSecret,
    setClientSecret
  });

  return (
    selectedCluster?.authentication === 'CLIENT_CREDENTIALS' && (
      <Checkbox
        id="remember-credentials"
        labelText="Remember credentials"
        checked={rememberCredentials}
        onChange={() => setRememberCredentials(!rememberCredentials)}
      />
    )
  );
}
